/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IncidentReportFromJSON, IncidentReportToJSON, } from './IncidentReport';
/**
 * Check if a given object implements the IncidentReportEntityCursorPageResponse interface.
 */
export function instanceOfIncidentReportEntityCursorPageResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function IncidentReportEntityCursorPageResponseFromJSON(json) {
    return IncidentReportEntityCursorPageResponseFromJSONTyped(json, false);
}
export function IncidentReportEntityCursorPageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': !exists(json, 'count') ? undefined : json['count'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(IncidentReportFromJSON)),
    };
}
export function IncidentReportEntityCursorPageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'totalCount': value.totalCount,
        'next': value.next,
        'previous': value.previous,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(IncidentReportToJSON)),
    };
}
